import { Controller } from "@hotwired/stimulus"

// Folds the footer sitemap on small screens.
//
// The sections are <details open> in the HTML on purpose: the whole sitemap is
// in the served markup for crawlers and for anyone without JS, and mobile-first
// indexing means the mobile rendering is the one Google reads. This only CLOSES
// them, and only below the desktop breakpoint — nothing is ever removed.
//
// Driven by matchMedia rather than a resize listener so it fires once when the
// breakpoint is actually crossed, not on every pixel of a resize. A section the
// visitor opens stays open: we only re-apply on a breakpoint change.
export default class extends Controller {
  static targets = ["section"]
  static values = { breakpoint: { type: Number, default: 1024 } }

  connect() {
    this.folded = window.matchMedia(`(max-width: ${this.breakpointValue - 1}px)`)
    this.apply = this.apply.bind(this)
    this.folded.addEventListener("change", this.apply)
    this.apply()
  }

  disconnect() {
    this.folded.removeEventListener("change", this.apply)
  }

  apply() {
    this.sectionTargets.forEach((section) => {
      section.open = !this.folded.matches
    })
  }
}
